import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import EmailTemplateType from './EmailTemplateType';

export default class UpdateEmailTemplateRequest extends BaseUpdateRequest {
	name = '';  
	templateId = ''; 
	type: EmailTemplateType; 
    
}